import { gql, useMutation } from "@apollo/client";
import { DialogContent } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useAppDialog } from "../../../app-dialog";
import { EventResourceFragment, EventResourceModel } from "../../../models/event-resource.model";
import { BasicDialogActions } from "../../../ui/dialog";
import { LoadingButton } from "../../../ui/loading-button";
import { ResourceForm } from "./resource-form";
import { ResourceInitialValues, ResourceValidationSchema } from "./resource-validation";

const MUTATION = gql`
    mutation insert($object: event_resource_insert_input!) {
        insert_event_resource_one(object: $object) {
            ${EventResourceFragment}
        }
    }
`;

type Props = {
    event_id: number;
    onFinish: (product: EventResourceModel, is_new?: boolean) => void;
}

export const ResourceCreate = ({
    event_id,
    onFinish,
}: Props) => {
    const [insert, status] = useMutation(MUTATION)
    const app_dialog = useAppDialog();

    const onSubmit = async (values: any) => {
        try {
            const { data } = await insert({
                variables: {
                    object: {
                        ...values,
                        event_id,
                    }
                }
            });
            const not = data?.insert_event_resource_one;
            if (!not) {
                return;
            }
            onFinish(not, true);
        } catch (e: any) {
            app_dialog.showError(e);
        }
    }
    return <Formik initialValues={ResourceInitialValues()}
        validationSchema={ResourceValidationSchema}
        onSubmit={onSubmit}>{(form_props) => <Form noValidate>
            <DialogContent>
                <ResourceForm {...form_props} />
            </DialogContent>
            <BasicDialogActions>
                <LoadingButton loading={status.loading}
                    color='primary'
                    type='submit'
                    size='large'
                    variant='contained'>
                    Create
                </LoadingButton>
            </BasicDialogActions>
        </Form>}
    </Formik>
}
